import { colorBlack, colorGrey, colorOrange } from '@immosky/styles';
import { getRootVar } from '@immosky/shared';

interface IconSelection {
  small: string;
  medium: string;
  large: string;
}

export abstract class MapIconFactory {
  protected abstract readonly defaultIcons: IconSelection;

  protected readonly selectedIcons: IconSelection = {
    small: window.btoa(`
            <svg fill="${colorBlack}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                <circle cx="16" cy="16" r="12" />
                <circle cx="16" cy="16" opacity=".4" r="16" />
            </svg>
        `),

    medium: window.btoa(`
             <svg fill="${colorBlack}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
                 <circle cx="24" cy="24" r="14" />
                 <circle cx="24" cy="24" opacity=".4" r="19" />
                 <circle cx="24" cy="24" opacity=".4" r="24" />
             </svg>
        `),

    large: window.btoa(`
             <svg fill="${colorBlack}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76 76">
                 <circle cx="38" cy="38" r="20" />
                 <circle cx="38" cy="38" opacity=".4" r="19" />
                 <circle cx="38" cy="38" opacity=".4" r="26" />
                 <circle cx="38" cy="38" opacity=".4" r="32" />
                 <circle cx="38" cy="38" opacity=".4" r="38" />
             </svg>
        `),
  };

  createIconForCount(count: number): google.maps.Icon {
    return this.createIcon(
      this.getSVGUrlForCount(this.defaultIcons, count),
      this.getSizeForCount(count)
    );
  }

  createSelectedIconForCount(count: number) {
    return this.createIcon(
      this.getSVGUrlForCount(this.selectedIcons, count),
      this.getSizeForCount(count)
    );
  }

  private getSVGUrlForCount(iconSizes: IconSelection, count: number): string {
    let url = iconSizes.small;
    if (count >= 100) {
      url = iconSizes.large;
    } else if (count >= 10) {
      url = iconSizes.medium;
    }
    return url;
  }

  private getSizeForCount(count: number): number {
    let size = 32;
    if (count >= 100) {
      size = 76;
    } else if (count >= 10) {
      size = 48;
    }
    return size;
  }

  protected createIcon(url: string, size: number): google.maps.Icon {
    return {
      url: `data:image/svg+xml;base64,${url}`,
      scaledSize: new google.maps.Size(size, size),
    };
  }
}

export class DefaultMapIconFactory extends MapIconFactory {
  protected readonly defaultIcons: IconSelection = {
    small: window.btoa(`
            <svg fill="${getRootVar('--map-marker-color', colorOrange)}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                <circle cx="16" cy="16" r="12" />
                <circle cx="16" cy="16" opacity=".4" r="16" />
            </svg>
        `),

    medium: window.btoa(`
             <svg fill="${getRootVar('--map-marker-color', colorOrange)}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
                 <circle cx="24" cy="24" r="14" />
                 <circle cx="24" cy="24" opacity=".4" r="19" />
                 <circle cx="24" cy="24" opacity=".4" r="24" />
             </svg>
        `),

    large: window.btoa(`
             <svg fill="${getRootVar('--map-marker-color', colorOrange)}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76 76">
                 <circle cx="38" cy="38" r="20" />
                 <circle cx="38" cy="38" opacity=".4" r="19" />
                 <circle cx="38" cy="38" opacity=".4" r="26" />
                 <circle cx="38" cy="38" opacity=".4" r="32" />
                 <circle cx="38" cy="38" opacity=".4" r="38" />
             </svg>
        `),
  };

}

export class SimilarObjectMapIconFactory extends MapIconFactory {
  protected readonly defaultIcons: IconSelection = {
    small: window.btoa(`
            <svg fill="${colorGrey}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                <circle cx="16" cy="16" r="12" />
                <circle cx="16" cy="16" opacity=".4" r="16" />
            </svg>
        `),

    medium: window.btoa(`
             <svg fill="${colorGrey}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
                 <circle cx="24" cy="24" r="14" />
                 <circle cx="24" cy="24" opacity=".4" r="19" />
                 <circle cx="24" cy="24" opacity=".4" r="24" />
             </svg>
        `),

    large: window.btoa(`
             <svg fill="${colorGrey}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76 76">
                 <circle cx="38" cy="38" r="20" />
                 <circle cx="38" cy="38" opacity=".4" r="19" />
                 <circle cx="38" cy="38" opacity=".4" r="26" />
                 <circle cx="38" cy="38" opacity=".4" r="32" />
                 <circle cx="38" cy="38" opacity=".4" r="38" />
             </svg>
        `),
  };
}
